const ItemCollector = <T extends { id: string }>() => {
  const items = new Map();
  return {
    add(item: T) {
      items.set(item.id, item);
    },
    build(): T[] {
      return Array.from(items.values());
    },
  };
};

export default ItemCollector;
